import { Action, handleActions } from 'redux-actions'
import { call, select, takeLatest } from 'redux-saga/effects'
import { oc } from 'ts-optchain'

import { fetchDebitCardList, IDebitCardMainResponse } from '@/api/DebitCardApi'
import {
  DEBIT_CARD_ISSUE_ROUTES,
  DEBIT_CARD_ROUTES,
  ENTRY_ROUTE_QUERY,
} from '@/domains/CommonDomain'
import { IRootState } from '@/modules'
import { createFetchAction, createSaga } from '@/utils/actionUtils'
import { browserHistory, redirect } from '@/utils/historyUtils'

export interface IDebitCardListView {
  isFetched: boolean
}

export interface IDebitCardListState extends IDebitCardMainResponse {
  view: IDebitCardListView
}

const defaultViewState: IDebitCardListView = {
  isFetched: false,
}

const initialState: IDebitCardListState = {
  debitCardWithAmountList: [],
  totalAmountForMonth: '',
  view: defaultViewState,
}

export const DEBIT_CARD_LIST = 'DebitCardList'

export const debitCardListAsync = createFetchAction(DEBIT_CARD_LIST)

export const reducer = {
  [debitCardListAsync.SUCCESS]: (
    state: IDebitCardListState,
    action: Action<IDebitCardMainResponse>,
  ) => {
    return {
      ...state,
      ...action.payload,
      view: {
        isFetched: true,
      },
    }
  },
  [debitCardListAsync.FAILURE]: (state: IDebitCardListState) => ({
    ...state,
    errorMessage: 'error',
  }),
}

export const debitCardListSelector = {
  view: (state: IRootState) => oc(state[DEBIT_CARD_LIST]).view(defaultViewState),
  debitCardWithAmountList: (state: IRootState) =>
    oc(state[DEBIT_CARD_LIST]).debitCardWithAmountList([]),
  totalAmountForMonth: (state: IRootState) => oc(state[DEBIT_CARD_LIST]).totalAmountForMonth('0'),
}

export function* checkTotalDebitCardCount() {
  const debitCardWithAmountList = yield select(debitCardListSelector.debitCardWithAmountList)

  if (debitCardWithAmountList.length === 0) {
    yield call(redirect, `${DEBIT_CARD_ISSUE_ROUTES.DESIGN}?${ENTRY_ROUTE_QUERY}`)

    return
  }
  if (debitCardWithAmountList.length === 1) {
    const { debitCardNo, acctNo } = debitCardWithAmountList[0]

    yield call(
      redirect,
      `${DEBIT_CARD_ROUTES.DETAIL}/${debitCardNo}/${acctNo}?${ENTRY_ROUTE_QUERY}`,
    )

    return
  }
  if (debitCardWithAmountList.length >= 2) {
    const { location } = browserHistory

    if (location.pathname === DEBIT_CARD_ROUTES.ROOT) {
      yield call(redirect, `${DEBIT_CARD_ROUTES.LIST}?${ENTRY_ROUTE_QUERY}`)
    }

    return
  }
}

export const debitCardListReducer = handleActions(reducer, initialState)
export const debitCardListSaga = [
  takeLatest(debitCardListAsync.FETCH, createSaga(debitCardListAsync, fetchDebitCardList)),
  takeLatest(debitCardListAsync.SUCCESS, checkTotalDebitCardCount),
]
